import React from 'react';
import styles from "../CommonInputComponent/CommonInputComponent.module.scss";
import { errorMessages } from "@/utils/constants";
import Srcset from "@/components/common/Srcset";
const InputField = ({
  type,
  id,
  name,
  label,
  placeholder,
  autoComplete,
  ariaLabel,
  className,
  defaultValue,
  errorMessage,
  formError,
  onFocus,
  onChange,
  onBlur,
  value,
  alreadyAccount,
  alreadyAccountMsg,
  isEmail,
  isPassword,
  isSignInTab,
  togglePasswordVisibility,
  isPasswordVisible,
  setAutoFillEmail,
  setSignInTab,
  setShowResetPassword,
  isActivateAccountTab,
  updatedSuccess,
  isEditTab,
  successMsg,
  nameChanged,
  isConfirmPassword,
  confirmPasswordErrorMessage,
  tabIndex,
  subsEmail,
  isResetPassword,
  disabled,
}) => {
  return (
    <div className={`${styles.form_item} ${isPassword ? styles.pwd_field : ''} ${isPassword && (isSignInTab || isActivateAccountTab) ? styles.input_pwd: ''} ${isPassword && (isSignInTab || isActivateAccountTab) && errorMessage ? styles.pwd_error: ''} ${subsEmail ? styles.subs_email : ''} ${disabled ? styles.disabled : ''}`}>
      {alreadyAccountMsg && isActivateAccountTab && isPassword? (
        <span
          className={`${styles.form_error} x-small-xs x-small-sm x-small-md ${styles.form_block_error} text-align-left`}
        >
          {alreadyAccountMsg}
        </span>
      ) : null}
      <div className={`${styles.input_wrapper}`}>
        <input
          type={isPassword ? (isPasswordVisible ?  'text' : 'password') : type}
          {...(id ? { id } : {})}
          name={name}
          placeholder={placeholder}
          autoComplete={autoComplete}
          aria-label={ariaLabel}
          className={`${className || ''} ${alreadyAccount ? " border-error" : ""} ${errorMessage || formError ? 'border-error ' : ''} ${isEditTab && updatedSuccess ? "input-success" : ""} ${styles.input_control} ${confirmPasswordErrorMessage ? "border-error" : ""}`}
          defaultValue={isActivateAccountTab && defaultValue ? defaultValue : ''}
          onFocus={onFocus}
          onChange={onChange}
          onBlur={onBlur}
          value={value}
          tabIndex={tabIndex}
          disabled={disabled ? true : false}
        />
        <label className={`x-small-xs small-sm small-md ${styles.input_label}`} htmlFor={id}>
          {label}
        </label>
      </div>
      {errorMessage && !isEditTab && !isResetPassword && <span className={`${styles.form_error} x-small-xs x-small-sm x-small-md`}>
      {errorMessage}
      </span>}
      {isConfirmPassword && confirmPasswordErrorMessage && <span className="error xx-small-xs x-small-sm x-small-md">{confirmPasswordErrorMessage}</span>}
      {errorMessage && isEditTab && (!isPassword || (isPassword && isConfirmPassword)) && <span className="error x-small-xs x-small-sm x-small-md form_error">{errorMessage}</span>}
      {
        (isEditTab && successMsg) || nameChanged ? (
          <span className="x-small-xs x-small-sm x-small-md form_error text-green">
            {isConfirmPassword ? successMsg : updatedSuccess}
          </span>
        ) : null
      }
      {alreadyAccount && isEmail ? (
        <span
          className={`${styles.form_error} ${errorMessage ? "d-none" : ""} x-small-xs x-small-sm x-small-md ${styles.form_block_error}`}>
          {errorMessage? null : alreadyAccountMsg}
        </span>
      ) : null}
      {isActivateAccountTab && (
        <>
          {alreadyAccountMsg && isEmail && (
            <span className={`${styles.form_error} x-small-xs x-small-sm x-small-md text-align-left ${styles.form_block_error}`}>
              {alreadyAccountMsg}
            </span>
          )}
          <span className={`x-small-xs x-small-sm x-small-md ${styles.form_error}`}>
            {errorMessage}
          </span>
          <span className={`x-small-xs x-small-sm x-small-md ${styles.form_error}`}>
            {formError}
          </span>
        </>
      )}
      {formError && isEmail && <span className={`x-small-xs x-small-sm x-small-md ${styles.form_error}`}>
          {formError}
        </span>}
      {isPassword && (
        <div
          className={`${styles.pwd_hide}`}
          onClick={togglePasswordVisibility}
          tabIndex={0}
        >
          {!isPasswordVisible ? (
            <Srcset
              src="images/Icons/Hide_Password.svg"
              svgFile={true}
              requirePath={true}
              className={`${styles.pwd_eye}`}
              alt="Password eye"
              height="17"
              width="21"
            />
          ) : (
            <Srcset
              svgFile={true}
              src="images/Icons/Show_Password.svg"
              requirePath={true}
              className={`${styles.pwd_eye}`}
              alt="Password eye"
              height="17"
              width="21"
            />
          )}
        </div>
      )}
      {alreadyAccount && isPassword ? (
          <div className={`${styles.signin_block}`}>
            <button
              onClick={() => {
                setAutoFillEmail(email);
                setSignInTab(true);
              }}
              className="btn-primary"
            >
              Sign in
            </button>
            <p>
              {" "}
              <a
                onClick={() => {
                  setShowResetPassword("resetPassword");
                }}
              >
                Forgotten password?
              </a>
            </p>
          </div>
        ) : null}
        {isPassword && (!isSignInTab && ((!isEditTab && !isResetPassword) || (isEditTab && !isConfirmPassword) || (isResetPassword && isConfirmPassword))) ? (
        <div className={`${styles.pwd_msg} ${alreadyAccountMsg && isActivateAccountTab? "mt-40" : ""}`}>
          {errorMessage ? (
            <img
              height="15"
              width="15"
              src="/icons/tooltip-red.svg"
              alt="password info"
              className={`${styles.pwd_icon}`}
            />
          ) : (
            <img
              height="15"
              width="15"
              src="/icons/tooltip.svg"
              alt="password info"
              className={`${styles.pwd_icon}`}
            />
          )}
          <p
            className={`xx-small-xs x-small-sm x-small-md ${
              errorMessage ? "text-red" : ""
            }`}
          >
            {errorMessages.authentication.invalidPassword}
          </p>
        </div>) : null}
      
    </div>
  );
};
export default InputField;